module.exports = "/wp-content/plugins/ratis-app-calculate-compensation/dist/loader.svg?202ff75439e7f5369f237094e880fd2b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.svg
// module id = 512
// module chunks = 0